import { useState } from "react";
import { Button, Col, Row } from "reactstrap";
import { DatePicker } from "antd";
import { useQuery } from "react-query";
import TurnOver from "./turnover";
import TransfertOperator from "./transfertOperator";

import { Link, useLocation } from "react-router-dom";
import ReversementsHistoryCC from "../../versement/component/historique/reversementsHistoryCC";
import back from "../../../assets/images/back.png";
import { DownloadOutlined } from "@ant-design/icons";
import CardMetrics from "../../../common/card/cardMetric";
import "../utils/style.css";
import { getDetailCountryPerMerchantCC } from "../../developer/services/developerApi";


const DetailCountry = () => {
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [amount, setAmount] = useState(0);

    const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
    const merchandId = currentUser?.user?.id || currentUser?.user?.merchantId;

    const location = useLocation();
    const { countryName, flag, countryCode  } = location.state || {};

    const {
      data: detailCountry,
      isLoading: isLoadingTrans,
      isError: isErrorTrans,
      error: errorTrans,
    } = useQuery(
        ["detailCountry", merchandId],
        () => getDetailCountryPerMerchantCC(merchandId, countryCode),
        { enabled: !!merchandId && !!countryCode }
    );

  return (
    <div>
      <div className="title-page-country d-flex align-items-center gap-2 flex-wrap mb-4">
        <Link to="/dashboard"><img src={back} /></Link> {" "} 
        {flag && <img src={flag} alt={`${countryName} flag`} className="flag-img" />}{" "}
        {countryName} {" "}
        <DatePicker placeholder="2025" picker="year" className="dashboardDate"/>
      </div>
      
      <Link to="/versement"><Button className='btn-ask-versement mb-4 mt-2'><DownloadOutlined /> Demander un reversement</Button></Link>

      <CardMetrics data={detailCountry} turnOver={detailCountry?.revenue} isLoading={isLoadingTrans} isError={isErrorTrans} error={errorTrans}/>

      <Row className='mb-2'>
        <Col lg={12} className="mb-2">
          <ReversementsHistoryCC countryCode ={countryCode}/>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col lg={8} className="mb-2">
            <TurnOver title="Chiffre d'affaires annuels" setAmountForHome={setAmount} />
        </Col>
        <Col lg={4}>
            <TransfertOperator />
        </Col>
      </Row>
    </div>
  );
};

export default DetailCountry;
